import { Tooltip } from "@mui/material";
import { ArrowLineRight } from "@phosphor-icons/react";
import style from "./style.module.css";
import { useEffect, useRef, useState } from "react";
import { Microphone, MicrophoneSlash } from "@phosphor-icons/react/dist/ssr";
import { Autorenew } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import { URL } from "../../../variables";
import { logout } from "../../../actions/AppActions";
import { getLanguageTexts, getSelectedLanguage } from "../../../languages";
import Loader from "../../../components/Loader";

export default function Info({
  show_info,
  setShowInfo,
  getAdminId,
  entrevistas,
  students, id_candidato,
  changeStudent,
  play_pause_timer,
          loading_timer

}) {
  const [student, setStudent] = useState({});
  const token = useSelector(store=>store.AppReducer.token);
  const processo = useSelector(store=>store.AppReducer.processo);


  const [show_warning, setShowWarning] = useState(false);
  const [first, setFirst] = useState(true);
  const dispatch = useDispatch();


  const [loading, setLoading] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(getSelectedLanguage());
  const t = getLanguageTexts(selectedLanguage);

  const [notas_criterios, setNotasCriterios] = useState({});
  const [notas, setNotas] = useState({});
  const [show_warning_validation,setShowWarningValidation] = useState(false)
  const [msgValidation,setMsgValidation] = useState('')
  const [ show_warning_success,setShowWarningSuccess] = useState(false);

  useEffect(() => {
    const handleLanguageChange = () => setSelectedLanguage(getSelectedLanguage());
    window.addEventListener('avaliador_language_change', handleLanguageChange);
    return () => window.removeEventListener('avaliador_language_change', handleLanguageChange);
  }, []);

  useEffect(() => {
    let stude=students.filter((item) => item.id == id_candidato)[0];
    setStudent(stude)
    // console.log('stude',stude)

    if(first==true){
      let notas={}
      stude?.exams_oral?.grades.map((item)=>{
        notas[item.criterio_id]=item.grade;
      })
      setNotasCriterios(notas);
      setFirst(false);
    }
  }, [students, id_candidato])
  useEffect(()=>{
    if(entrevistas[0]!=undefined){
      let notas={};
      entrevistas[0].criterios.map((item)=>{
        notas[item.id]=[]
        let nota = parseFloat(item.min_score);
        while(nota<=parseFloat(item.max_score)){
          notas[item.id].push(parseFloat(parseFloat(nota).toFixed(2)));
          nota+=0.25;
        }
      })
      setNotas(notas);
      
    }
  },[entrevistas])

  const saveGrades = (finish)=>{
    setLoading(true)
    fetch(`${URL}api/avaliador/save_grades`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            student_id: student.id,
            entrevista_id: entrevistas[0].id,
            processo_id: processo.id,
            finish,
            notas_criterios
        })
    }).then(async (responseLog) => {
        try {
            let resp = await responseLog.json();
            console.log(resp)
            if (resp.message == "Unauthenticated.") {
                                localStorage.removeItem('token');
                                // this.setState({redirect:true,path:'/'});
                                dispatch(logout())
                            }
            else if (resp.errors != null || resp.error != null) {
                let errors = Object.values(resp.errors);
                let erro = '';
                for (let i = 0; i < errors.length; i++) {
                    if (i != errors.length - 1)
                        erro += errors[i] + '\n';
                    else
                        erro += errors[i];
                }
                console.log(erro);
                setMsgValidation(t.grade_validation)
                setShowWarningValidation(true)
                setLoading(false);
            }
            else if(resp.message!=undefined){
                setMsgValidation(t.save_error_try);

                setShowWarningValidation(true)
            }
            else {
              changeStudent(resp.candidato);
              setStudent(resp.candidato)
              setLoading(false);
              setShowWarningSuccess(true)

            }




        } catch (err) {
            console.log(err);
            setLoading(false);
            setMsgValidation(t.save_error_try);

            setShowWarningValidation(true)
            // this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor' });
          
        }

    })
        .catch((err) => {
            console.log(err);
            setLoading(false);
            setMsgValidation(t.save_error_connection);

            setShowWarningValidation(true)
            // this.setState({ loading: false, msgErro: 'Erro ao pegar resposta do servidor. Você está conectado a internet?' });
        });
  }
  // console.log('student', student)
  return (
    <div
      className={`Transition-1 avaliador-meet-side-panel avaliador-meet-info-panel ${show_info ? 'is-open' : 'is-closed'}`}
      style={{
        height: "100%",
        maxWidth: '50vw',
        width: "100%",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        backgroundColor: "var(--background-color0)",
        borderRadius: "1rem",
        padding: "1rem",
        position: "absolute",
        top: "0",
        right: "0",
      }}
    >
      {/* header */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: "0.6rem",
        }}
      >
        <span
          style={{
            fontSize: "1.4rem",
            fontWeight: "bold",
          }}
        >
          {t.evaluation_info}
        </span>
        <Tooltip
          title={
            <span
              style={{
                fontSize: "1rem",
                textAlign: "center",
              }}
            >
              {t.hide_info}
            </span>
          }
          placement="bottom"
          arrow
          onClick={() => setShowInfo(false)}
        >
          <ArrowLineRight size={24} />
        </Tooltip>
      </div>

      {/* participants container */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          height: "100%",
          overflowY: "auto",
        }}
      >
        {entrevistas.map((item, id) => (

          <div key={id} style={{ marginTop: '1rem' }}>
            <h5 className="mt-0 header-title" style={{ fontSize: '1.5rem', textAlign: 'center' }}>
              {item.name}</h5>
            <p style={{ whiteSpace: 'pre-line' }}><b style={{ color: 'var(--text-color0)', fontSize: 18 }}>{t.general_info}</b> <div dangerouslySetInnerHTML={{ __html: item.descricao }}></div></p>
            
            <div style={{ marginTop: 10 }}>
              {item.topicos.map((item2, id2) => (
                <div key={id2} style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}><div style={{ background: 'var(--text-color0)', borderRadius: 100, minWidth: 6, minHeight: 6, marginRight: 5 }}></div> <span>{item2.text}</span></div>
              ))}
            </div>
            <hr/>
            <p style={{ whiteSpace: 'pre-line' }}><b style={{ color: 'var(--text-color0)', fontSize: 18 }}>{t.evaluator_guidance}</b> <div dangerouslySetInnerHTML={{ __html: item.info }}></div></p>
            <hr/>
            <p style={{ color: 'var(--text-color0)', textAlign: 'center', marginBottom: 10 }}><b >{t.scheduled_datetime}</b> {student?.exams_oral?.datetime_initial ? moment(student.exams_oral?.datetime_initial).format('DD/MM/YYYY HH:mm') : '-'} {t.until} {student?.exams_oral?.datetime_end ? moment(student.exams_oral?.datetime_end).format('DD/MM/YYYY HH:mm') : '-'}</p>
            <p style={{ color: 'var(--text-color0)', textAlign: 'left', marginBottom: 10 }}><b >{t.timer_records}</b></p>
            {student?.timers?.length==0 && <p  style={{ color: 'var(--text-color0)', textAlign: 'left', marginBottom: 10 }}>{t.no_records}</p>}
            {student?.timers?.map((item2,id2)=>{
             return <p key={id2} style={{ color: 'var(--text-color0)', textAlign: 'left', marginBottom: 10 }}><b>{(item2.type=='play' && id2==0)?t.started_at:(item2.type=='play'?t.returned_at:t.paused_at)}</b> {moment(item2.timer).format('DD/MM/YYYY HH:mm:ss')}</p>
            })}
            
            <div className="d-flex justify-content-center">
            {loading_timer==false ? <button type="button"  className="btn btn-warning btn-lg btn-outline btn-circle w-100 mb-2 mt-2" onClick={()=>{
              play_pause_timer();
            }} >{student?.timers?.length? (student?.timers[student?.timers.length-1].type=='play'?t.pause_evaluation:t.resume_evaluation):t.start_evaluation} <i
            className="mdi mdi-play"
            
            style={{  fontStyle: 'normal' }}
            >
                </i></button>:<Loader compact title={t.loading} description={null} />}
              </div>
            <p style={{}}><b style={{ color: 'var(--text-color0)', fontSize: 18, marginTop: 10 }}>{t.criteria}</b> </p>

            

            <div className="table-rep-plugin">
              <div className="table-responsive mb-0" data-pattern="priority-columns">
                <table className="table table-striped">
                  <thead>
                    <tr>

                      <th>{t.criterion_code}</th>
                      <th>{t.criterion_text}</th>
                      <th>{t.range}</th>
                      <th>{t.grade}</th>
                    </tr>

                  </thead>
                  <tbody >

                    {item.criterios.map((item2, id) => (
                      <tr key={id}>
                        <td>
                          {item2.code}

                        </td>
                        <td>
                          {item2.text}

                        </td>
                        <td>
                          {item2.min_score} - {item2.max_score}

                        </td>
                        <td>
                          <select value={notas_criterios[item2.id] ?? ''} style={{minWidth:'80px'}} className="custom-select" id="cameras" onChange={(e) => {
                            let notas = {...notas_criterios}
                            notas[item2.id]=e.target.value;
                            setNotasCriterios(notas);
                          }}>
                            <option value={''}>{t.select_grade}</option>
                            {notas[item2.id]?.map((item3,id3)=>(
                            <option key={id3} value={item3}>{item3}</option>
                            ))}
                          </select>

                        </td>
                      </tr>
                    ))}





                  </tbody>
                </table>
              </div>
            </div>
            <p style={{ color: 'var(--text-color0)',  marginBottom: 10 }}><b >{t.final_grade}</b> {Object.values(notas_criterios).reduce((accumulator, currentValue) => {
  return parseFloat(accumulator) + parseFloat(currentValue)
},0)}</p>


            <hr />
            <div className="avaliador-meet-info-actions" style={{display:'flex',justifyContent:'flex-end'}}>
            {loading==false && <button type="button"  className="btn btn-success btn-lg btn-outline btn-circle m-r-5" onClick={()=>{
              saveGrades(false);
            }} >{t.save_grades} <i
            className="mdi mdi-check"
            
            style={{  color: 'white', fontStyle: 'normal' }}
            >
                </i></button>}
                {loading==false && !student?.exams_oral?.finish && <button type="button"  className="btn btn-danger btn-lg btn-outline btn-circle m-r-5"
                onClick={()=>{
                  setShowWarning(true);
                }}
                >{t.finish_disconnect} <i
            className="mdi mdi-close"
            style={{  color: 'white', fontStyle: 'normal' }}
            >
                </i></button>}

            {loading==true && <Loader compact title={t.loading} description={null} />}
              </div>
          </div>
        ))}

<SweetAlert
                        warning
                        title={t.attention}
                        onConfirm={()=>{
                          setShowWarning(false);
                          saveGrades(true);
                        }}
                        onCancel={()=>{
                          setShowWarning(false);
                        }}
                        show={show_warning}
                        confirmBtnText={t.confirm_finish}
                        cancelBtnText={t.cancel}
                        confirmBtnBsStyle="success"
                        cancelBtnBsStyle="danger"
                        showCancel={true}
                    >
                        {t.finish_warning}
                    </SweetAlert>

                    <SweetAlert
                        warning
                        title={t.attention}
                        onConfirm={()=>{
                          setShowWarningValidation(false);
                        }}
                      
                        show={show_warning_validation}
                        confirmBtnText='Ok'
                        confirmBtnBsStyle="danger"
                        showCancel={false}
                    >
                        {msgValidation}
                    </SweetAlert>

                    <SweetAlert
                        success
                        title={t.success}
                        onConfirm={()=>{
                          setShowWarningSuccess(false);
                        }}
                      
                        show={show_warning_success}
                        confirmBtnText='Ok'
                        confirmBtnBsStyle="success"
                        showCancel={false}
                    >
                        {t.save_success}
                    </SweetAlert>

      </div>
    </div>
  );
}
